"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Styles = require("./search-result.styles");
const component_text_1 = require("@patternplate/component-text");
class SearchResult extends React.Component {
    constructor() {
        super(...arguments);
        this.ref = null;
        this.saveRef = (ref) => {
            this.ref = ref;
        };
    }
    componentWillUpdate(next) {
        if (next.active && this.ref) {
            this.props.onScrollRequest({ target: this.ref });
        }
    }
    render() {
        const props = this.props;
        return (React.createElement(Styles.StyledResult, { ref: this.saveRef, title: `Navigation to pattern ${props.name}`, "data-id": props.id },
            React.createElement(Styles.StyledResultLink, { active: props.active, href: props.href, query: { "search-enabled": false } },
                React.createElement(Styles.StyledResultLinkText, { active: props.active }, props.name)),
            React.createElement(Styles.StyledPreviewLink, { active: props.active, query: { "search-preview": props.index } },
                React.createElement(component_text_1.Text, null, "Preview"))));
    }
}
exports.SearchResult = SearchResult;
//# sourceMappingURL=search-result.js.map